import { InjectionToken } from "@angular/core";

export class AuthorizationAppConfiguration {
    applicationRoot: string;
}

export const AUTHORIZATION_APP_CONFIGURATION = new InjectionToken<
    Promise<AuthorizationAppConfiguration>
>("AuthorizationAppConfiguration");
